module.exports = __webpack_public_path__ + "static/media/hearts-king.c6bc0f41.png";